export default __webpack_public_path__ + "static/media/auth0.85db9acc.svg";